import type { AdministrationLocales } from '@/types/lang/locales'

export const administrationEn: AdministrationLocales = {}
